<template>
  <div class="circle" @click="back">返回</div>
</template>
<script>
export default {
  data() {
    return {

    }
  },

  methods: {
    back() {
      this.$emit('back')
    }
  }
}
</script>

<style scoped>
.circle {
  width: 60px;
  height: 60px;
  position: fixed;
  right: 30px;
  top:150px;
  background: rgba(36, 6, 204, 0.705);
  z-index: 9999;
  border-radius: 50%;
  color: #fff;
  line-height: 60px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/CircleBtn.vue